export function isEUCountry(countryCode: string | null): boolean {
  const euCountriesCodeMap: Record<string, boolean> = {
    AT: true,
    BE: true,
    BG: true,
    HR: true,
    CY: true,
    CZ: true,
    DK: true,
    EE: true,
    FI: true,
    FR: true,
    DE: true,
    GR: true,
    HU: true,
    IE: true,
    IT: true,
    LV: true,
    LT: true,
    LU: true,
    MT: true,
    NL: true,
    PL: true,
    PT: true,
    RO: true,
    SK: true,
    SI: true,
    ES: true,
    S: true,
  };
  return !!countryCode && euCountriesCodeMap[countryCode.toUpperCase()];
}
